<div class="container">
  @if (!themeService.spinnerConfig().isCustom) {
    <ion-spinner name="crescent" class="ion-margin" />
  }
  @if (themeService.spinnerConfig().isCustom) {
    <div class="custom-spinner"></div>
  }
</div>
